import { createContext } from "react";

const ReportsContext = createContext();

export default ReportsContext;
